<template>
  <div>
    <subject-title></subject-title>
  </div>
</template>


<script>
import SubjectTitle from './Title'

export default {
  name: 'SubjectArea',
  components: { SubjectTitle }
}
</script>


<style>

</style>


// WEBPACK FOOTER //
// src/components/main/SubjectArea.vue